import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';

class PayoutFactorAll extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            report: [],
            sortParam: null,
            sortOrder: 1,
            isLoading: false
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.updateFactor = this.updateFactor.bind(this);
    }

    componentDidMount() {
        Promise.all([
            API.PayoutFactor.getAffid()
        ]).then(([ affids ]) => {
            this.setState({ affidValues: affids })
        })
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam !== sortParam || this.state.sortOrder !== sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleFieldChange(event) {
        const { value, name } = event.target;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === "subid") {
            API.PayoutFactor.getSubidsAll(filters)
                .then(subids => this.setState({ subidValues: subids, isLoading: false }));
        } else {
            API.PayoutFactor.getAll(filters).then(({ report }) => {
                this.setState({ report, isLoading: false })
            });
        }
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }


    updateFactor(affid, subid, country) {
        const cutoff = prompt("Enter new cutoff: ");
        if(!cutoff || isNaN(cutoff)) return alert("Please enter correct number.");

        if(!window.confirm(`Are you sure to set cutoff: ${cutoff} for '${affid}:${subid}:${country}'?`)) return;

        this.setState({ isLoading: true })

        API.PayoutFactor.updateFactor(affid, subid, country, cutoff).then(() => {
            this.setState({ isLoading: false })
        })
    }

    getTable() {
        const { report, reportTotal } = this.state;

        return report.length ?
            <Table report={report} updateFactor={this.updateFactor} total={reportTotal} onSortChange={this.handleSort} /> :
            <p>No Data</p>
    }

    render() {
        const { isLoading, affidValues, subidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Payout Factor ALL"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} subidValues={subidValues}/>

                {this.getTable()}
            </Container>
        );
    }
}

export default PayoutFactorAll;


// WEBPACK FOOTER //
// ./src/scenes/PayoutFactorAll/index.js